/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import AiManagementSummaryCard from 'components/atoms/ai_management_summary_card';
import AiManagementCollapsibleCard from 'components/molecules/ai_management_collapsible_card';
import AiManagementDataCard from 'components/molecules/ai_management_data_card';
import { PossibleCompetitorExperienceCounts } from 'services/actions/ai_management_possible_competitors';
import { count } from 'services/ai_management_format';
import { Content } from './styles';

export interface ExperienceRow extends PossibleCompetitorExperienceCounts {
  key: string;
  label: string;
}

interface AiManagementCompetitorExperienceProps {
  title: string;
  columnLabel: string;
  summary: string | null;
  rows: ExperienceRow[];
  className?: string;
}

const PREVIEW = 5;

const COLUMNS: Array<{ key: keyof PossibleCompetitorExperienceCounts; label: string }> = [
  { key: 'licitacoes', label: 'Quant. Licitações' },
  { key: 'adjudicados', label: 'Itens adjudicados' },
  { key: 'desclassificados', label: 'Itens desclassificados' },
  { key: 'inabilitados', label: 'Itens inabilitados' },
];

const AiManagementCompetitorExperience: React.FC<AiManagementCompetitorExperienceProps> = ({
  title,
  columnLabel,
  summary,
  rows,
  className = '',
}) => {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? rows : rows.slice(0, PREVIEW);

  return (
    <AiManagementCollapsibleCard title={title} className={className}>
      {summary ? (
        <AiManagementSummaryCard className="mb-3">{summary}</AiManagementSummaryCard>
      ) : null}

      <AiManagementDataCard compact>
        <Content className="table-responsive">
          <table className="table bg-white mb-0">
            <thead className="thead-light">
              <tr>
                <th scope="col">{columnLabel}</th>
                {COLUMNS.map((column) => (
                  <th key={column.key} scope="col" className="text-center">
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {visible.length ? (
                visible.map((row) => (
                  <tr key={row.key}>
                    <td className="label-cell">{row.label}</td>
                    {COLUMNS.map((column) => (
                      <td key={column.key} className="text-center">
                        {count(row[column.key])}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={COLUMNS.length + 1} className="text-muted">
                    Nenhum registro encontrado.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Content>
      </AiManagementDataCard>

      {rows.length > PREVIEW ? (
        <div className="text-center mt-3">
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={() => setExpanded((current) => !current)}
          >
            {expanded ? 'Ver menos' : `Ver todos (${rows.length})`}
          </button>
        </div>
      ) : null}
    </AiManagementCollapsibleCard>
  );
};

export default AiManagementCompetitorExperience;
